export default __webpack_public_path__ + "static/media/gas.b5d9b9c5.svg";